export default "__VITE_ASSET__Bx4cK9wL__"